/**
 * Basic location verification module
 *
 * @author slanden (slanden@yext.com)
 */
goog.provide('yext.basiclocation.verification');

goog.require('yext');
goog.require('yext.Field');
goog.require('yext.basiclocation');
goog.require('yext.imageloader');
goog.require('yext.location.info');
goog.require('yext.notify');
goog.require('yext.textutil.CharacterCounter');

/**
 * Initialize this module
 */
yext.basiclocation.verification.init = function() {
  yext.imageloader.init({
    acceptedFileTypes: /^(image|application|text)/,
    badFileTypeMsg: yext.msg('Unrecognized file format. Please select a JPG, PNG, BMP, TIFF, GIF or WEBP.'),
  });
  yext.basiclocation.verification.$form = $('.js-submit-verification-form');
  yext.basiclocation.verification.$imageLoader = $('.js-upload-document-dialog');
  yext.basiclocation.verification.field = new yext.Field(yext.basiclocation.verification.$form);
  yext.basiclocation.verification.initDialog();
  yext.basiclocation.verification.initField();
  yext.basiclocation.verification.bindFileUpload();
  yext.basiclocation.verification.bindCommentCharacterCount();
};
goog.exportSymbol('yext.basiclocation.verification.init', yext.basiclocation.verification.init);

/**
 * Initialize the dialog
 */
yext.basiclocation.verification.initDialog = function() {
  var $dialog = $('.js-verify-without-document-dialog');
  $dialog.dialog({
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    width: 400,
    title: yext.msg('No Official Document'),
  });

  $dialog.find('.js-cancel').click(function() {
    $dialog.dialog('close');
  });

  $dialog.find('.js-submit-without-verification-button').click(function() {
    yext.basiclocation.verification.field.submit();
  });
};

/**
 * Bind form submit
 */
yext.basiclocation.verification.initField = function() {
  yext.basiclocation.verification.field.setValidator(yext.basiclocation.verification.checkErrors);

  yext.basiclocation.verification.$form.on('always.field', function() {
    $('.js-verify-without-document-dialog').dialog('close');
  });

  yext.basiclocation.verification.$form.on('error.field', function() {
    yext.basiclocation.verification.removeFile();
    yext.basiclocation.verification.showGenericError();
  });

  yext.basiclocation.verification.$form.on('save.field', function(success) {
    if (success) {
      window.location.href = '/s/' + yext.businessId + '/locations/confirmBasicLocation?locationId=' + $('[name="locationId"]').val();
    } else {
      yext.basiclocation.verification.removeFile();
      yext.basiclocation.verification.showGenericError();
    }
  });
};

/**
 * Check that the form has no errors, and display errors if present.
 */
yext.basiclocation.verification.checkErrors = function() {
  yext.basiclocation.verification.$form.find('.js-error').hide();
  var valid = true;
  if (!$('.js-business-relationship-input:checked').val()) {
    $('.js-business-relationship-row .js-error').show();
    valid = false;
  }
  if (yext.basiclocation.verification.field.files.length == 0) {
    $('.js-official-document-row .js-error').show();
    valid = false;
  }
  if ($('.js-additional-comments-input').val().length > 1024) {
    $('.js-comments-max-characters-error').show();
    valid = false;
  }
  return valid;
};

/**
 * Shows a generic error toast
 */
yext.basiclocation.verification.showGenericError = function() {
  $('.js-verify-without-document-dialog').dialog('close');
  yext.notify.showError(yext.msg('There was an error while submitting the verification request. Please review your submission and try again'));
};

/**
 * Dialog for location reverification
 *
 * @constructor
 */
yext.basiclocation.verification.ReverificationDialog = function() {
  this.$dialog = yext.basiclocation.$reverifyListingTemplate.clone();
  this.$dialog.find('.js-error-message').text(
    yext.location.info.locationId == 0
      ? yext.msg('If you change your business names, you will have to verify your listings again.')
      : yext.msg('If you change your business name or address, you will have to verify your listing again.'));
  this.bindDialog();

  this._onRequest = function() {};
};

/**
 * Set title and bind button actions
 */
yext.basiclocation.verification.ReverificationDialog.prototype.bindDialog = function() {
  var self = this;
  this.$dialog.dialog(
    $.extend({
      title: yext.msg('Verify Listing'),
      width: 400,
    }, yext.basiclocation.defaultDialogOptions));

  this.$dialog.find('.js-cancel').click(function() {
    self.$dialog.dialog('destroy');
  });

  this.$dialog.find('.js-reverify-listing-button').click(function() {
    self._onRequest();
    self.$dialog.dialog('destroy');
  });
};

/**
 * Set the on request callback
 *
 * @param {function()} cb Callback to fire off the suggest request
 */
yext.basiclocation.verification.ReverificationDialog.prototype.onRequest = function(cb) {
  if (yext.isFunction(cb)) {
    this._onRequest = cb;
  }
};

/**
 * Show the re-verification dialog
 *
 * @param {function()} cb The request callback
 */
yext.basiclocation.verification.showReverificationDialog = function(cb) {
  var reverificationDialog = new yext.basiclocation.verification.ReverificationDialog();
  reverificationDialog.onRequest(cb);
  reverificationDialog.$dialog.dialog('open');
};

/**
 * Check if reverification is required and execute callback
 *
 * @param {function()} cb callback
 */
yext.basiclocation.verification.checkRequiresReverification = function(cb, data) {
  if (yext.location.info.isBulkEdit) {
    cb(true);
  } else {
    $.ajax({
      method: 'POST',
      url: '/s/' + yext.businessId + '/locations/requiresReverification',
      data: data.concat(
        [{'name': 'locationId', 'value': yext.location.info.locationId},
          {'name': 'businessId', 'value': yext.businessId}]),
      success: function(requiresReverification) {
        cb(requiresReverification);
      },
    });
  }
};

/**
 * Mark a location for verification
 *
 * @param {function()} cb callback
 */
yext.basiclocation.verification.markForReverification = function(cb, name) {
  $.ajax({
    method: 'POST',
    url: '/s/' + yext.businessId + '/locations/markLocationForReverification',
    data: {
      'locationSearchParam': encodeURIComponent(window.location.search.substring(1)),
      'businessId': yext.businessId,
      'name': name,
    },
    success: cb,
  });
};

/**
 * Process location field reverification if needed
 *
 * @param {!Object} locationField
 * @param {!Object} textField
 */
yext.basiclocation.verification.processLocationFieldReverification = function(locationField, textField) {
  if (yext.location.info.isYahooBasicAccount
    && locationField.fieldName === 'virtual.name'
    && (yext.location.info.hasOnlyBasicLocations
    || (yext.location.info.isBulkEdit && yext.location.info.isYahooBasicAccount))) {
    locationField.field.preventDefault();
    locationField.hideDelayedProgressDialog();
    yext.basiclocation.verification.checkRequiresReverification(function(requiresReverification) {
      if (requiresReverification) {
        yext.basiclocation.verification.showReverificationDialog(function() {
          yext.basiclocation.verification.markForReverification(function() {
            locationField.field.submit();
          },
          textField.value());
        });
        locationField.field.enableSubmit();
      } else {
        locationField.field.submit();
      }
    },
    [{'name': 'name', 'value': textField.value()}]);

    locationField.$form.on('save.field', function(e, response) {
      if (!yext.location.info.isBulkEdit) {
        window.location.reload();
      }
    });
  }
};

/**
 * Bind the official document upload
 */
yext.basiclocation.verification.bindFileUpload = function() {
  yext.basiclocation.verification.$imageLoader.dialog({
    title: yext.msg('Add Document'),
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    width: 600,
  });

  yext.basiclocation.verification.$form.find('.js-official-document-upload').click(function() {
    yext.basiclocation.verification.$imageLoader.dialog('open');
  });

  $(yext.imageloader.events).on('add.imageloader', function(event, file) {
    yext.basiclocation.verification.field.addFile(file.file, file.fileInput);
    yext.basiclocation.verification.$imageLoader.dialog('close');
    $('.js-official-document-upload').hide();
    $('.js-official-document-wrapper')
      .show()
      .find('.js-official-document-name')
      .text(file.fileName);
  });

  $('.js-remove-item').click(function() {
    yext.basiclocation.verification.removeFile();
  });
};

/**
 * Remove a file from the file list and toggle the display status of the add file button
 */
yext.basiclocation.verification.removeFile = function() {
  $('.js-official-document-wrapper').hide();
  $('.js-official-document-upload').show();
  yext.basiclocation.verification.field.files = [];
};

/**
 * Show the character counts in the additional comments text area
 */
yext.basiclocation.verification.bindCommentCharacterCount = function() {
  var commentCounter = new yext.textutil.CharacterCounter($('.js-additional-comments-input'), {
    limit: 1024,
  });
};
